import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { projectMembersService } from '../api/projectMembers.service';
import { PROJECT_KEYS } from './queryKeys';

export function useUpdateProjectMember(projectId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const { toast } = useToast();
  const { t } = useTranslation('tasks');

  return useMutation({
    mutationFn: ({ memberId, role }: { memberId: string; role: string }) =>
      projectMembersService.update(projectId, memberId, { role }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECT_KEYS.members(orgId ?? '', projectId),
      });
      toast.success({ title: t('header.memberList.roleUpdated') });
    },
  });
}
